import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'wf-trial-counter-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class TrialChipComponent implements OnInit {
  readonly trialStatus = input<{
    [key: string]: string;
}>({});

  constructor() { }

  ngOnInit(): void {
  }
}
